// Dependencies
import { ChangeEventHandler, FC, FocusEventHandler } from "react";

// Styleds
import { StyledCheckbox, StyledFormItem } from "./FormCheckbox.styled";
interface FormCheckboxProps {
  label: string;
  name: string;
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
  value: boolean;
}

const FormCheckbox: FC<FormCheckboxProps> = ({ label, ...props }) => {
  return (
    <StyledFormItem
      control={<StyledCheckbox {...props} />}
      label={label}
    ></StyledFormItem>
  );
};

export default FormCheckbox;
